import * as React from "react";
import { Link } from "gatsby";

// Import styles
import "./styles/hero.scss";

// Bootstrap imports
import { Button, Col, Container, Jumbotron, Row } from "react-bootstrap";

const Hero = (props) => {
  let button = "";
  if (props.buttonText !== "") {
    button = (
      <Link to={props.buttonLink}>
        <Button variant="accent">{props.buttonText}</Button>
      </Link>
    );
  }
  let centeredClass = "centered";
  let content = "";
  if (props.description) {
    content = (
      <Col className="text" xs={12} md={12} lg={12}>
        <h1 className="shout">{props.title}</h1>
        <p className="talk">{props.description}</p>
        {button}
      </Col>
    );
  }
  if (props.htmlDescription) {
    content = (
      <Col className="text" xs={12} md={12} lg={12}>
        <h1 className="shout">{props.title}</h1>
        <div
          className="talk"
          dangerouslySetInnerHTML={{
            __html: props.htmlDescription,
          }}
        />
        {button}
      </Col>
    );
  }

  let image = "";

  if (props.image !== "") {
    centeredClass = "";
    if (props.description) {
      content = (
        <Col className="text" xs={12} md={8} lg={9}>
          <h1 className="shout">{props.title}</h1>
          <p className="talk">{props.description}</p>
          {button}
        </Col>
      );
    }
    if (props.htmlDescription) {
      content = (
        <Col className="text" xs={12} md={8} lg={9}>
          <h1 className="shout">{props.title}</h1>
          <div
            className="talk"
            dangerouslySetInnerHTML={{
              __html: props.htmlDescription,
            }}
          />
          {button}
        </Col>
      );
    }

    image = (
      <Col className="image" xs={6} md={4} lg={3}>
        {props.image}
      </Col>
    );
  }

  return (
    <Jumbotron
      fluid
      className={`hero ${props.customClass} ${props.format} ${centeredClass}`}
    >
      <div className="overlay" />
      <Container className="content fade-in-slow">
        <Row>
          {image}
          {content}
        </Row>
      </Container>
    </Jumbotron>
  );
};

export default Hero;
